import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Parser from 'html-react-parser';
import { Comment } from 'models/';
import CommentComponent from 'common/components/Comment/Comment';

export default class ArticleBodyParsed extends Component {
  static propTypes = {
    htmlBody: PropTypes.string
  };

  parserOptions = {
    replace: domNode => {
      if (domNode.name === 'object') {
        const model = domNode.attribs;
        switch (model.constructor) {
          case Comment.name:
            return <CommentComponent {...model} />;
          default:
            return <span> {/*Component not found*/} </span>;
        }
      }
    }
  };

  render() {
    const { htmlBody } = this.props;

    return htmlBody.length ? Parser(htmlBody, this.parserOptions) : null;
  }
}



// WEBPACK FOOTER //
// ./src/common/components/ArticleBodyParsed/ArticleBodyParsed.js